var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"h-100 m-0 p-0"},[_vm._v(" telegram ")])}
var staticRenderFns = []

export { render, staticRenderFns }